import { getEnv } from '@repo/utils';
import { BordeauxMachineContext, ThirdParty } from '@repo/shared-types';
import staticUserSyncIds from './userSyncIds';

const UID2_SERVER_PUBLIC_KEY =
  'UID2-X-P-MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAErrdS+bkwKS6LIcrT4BWG7CivsrOds0tGfY667NctMQNtutObZa3Od9Uw5It/GiQJxJ1qD1IO1sdFVqHw11srpA==';
const UID2_SUBSCRIPTION_ID = 'x2HQwg9gkp';
const LI_DISTRIBUTOR_ID = 'did-0043';
const LI_BIDDERS = [
  'rubicon',
  'pubmatic',
  'ix',
  'ttd',
  'grid',
  'medianet',
  'vidazoo',
  'triplelift',
  'sovrn',
  'openx',
  'unruly',
];

const uid2Entry = (email: string) => ({
  name: 'uid2',
  params: {
    serverPublicKey: UID2_SERVER_PUBLIC_KEY,
    subscriptionId: UID2_SUBSCRIPTION_ID,
    email,
  },
});

const liveIntentEntry = {
  name: 'liveIntentId',
  bidders: LI_BIDDERS,
  params: {
    publisherId: undefined,
    distributorId: LI_DISTRIBUTOR_ID,
    requestedAttributesOverrides: {
      uid2: true,
      index: true,
      bidswitch: true,
      medianet: true,
      pubmatic: true,
      magnite: true,
      openx: true,
      sovrn: true,
      thetradedesk: true,
      vidazoo: true,
      triplelift: true,
      nexxen: true,
    },
  },
  storage: { type: 'html5', name: '__tamLIResolveResult', expires: 1 },
};

export const buildUserSyncIds = (
  context: Pick<BordeauxMachineContext, 'liveIntentUserSyncEnabled' | 'thirdPartyApiConfig'>,
  uid2AlreadyResolved: boolean,
) => {
  const { enabled: uid2Enabled } = context.thirdPartyApiConfig[ThirdParty.UID2];
  const { liveIntentUserSyncEnabled } = context;
  const email = getEnv()?.FUTR?.Kiosq?.User?.email;

  return [
    ...staticUserSyncIds,
    ...(email && uid2Enabled && !uid2AlreadyResolved ? [uid2Entry(email)] : []),
    ...(liveIntentUserSyncEnabled && getEnv().liModuleEnabled ? [liveIntentEntry] : []),
  ];
};
